/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scene-group-item.vue?vue&type=template&id=6c58fbec&scoped=true&"
import script from "./scene-group-item.vue?vue&type=script&lang=ts&"
export * from "./scene-group-item.vue?vue&type=script&lang=ts&"
import style0 from "./scene-group-item.vue?vue&type=style&index=0&id=6c58fbec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58fbec",
  null
  
)

export default component.exports